import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import OrgRegistryBasicInfoComponent from './org-registry-basic-info.component';
import OrgRegistryKeyInfoComponent from './org-registry-key.component';


export const OrgRegistryComponent = ({ deliveryPreference,accountType,deleteKeys,onFormItemChange,keys,onFormChange,orgRegistry,fetchAcount,accounts,shippingProviders,id,selectedOrgRegistry,shippingTypes,back,handleFormSubmit}: any) => {
  
  const tabItems=[
    {
        id:1,
        title:'Basic Info',
        component:<OrgRegistryBasicInfoComponent
        id={id} 
        selectedOrgRegistry={selectedOrgRegistry}
        shippingTypes ={shippingTypes}
        shippingProviders={shippingProviders}
        accounts ={accounts}
        accountType={accountType}
        deliveryPreference={deliveryPreference}
        fetchAcount={fetchAcount}
        orgRegistry ={orgRegistry}
        onFormChange={onFormChange}
      />,
    isVisible:true,
    },
    {
        id:2,
        title:'Key Info',
        component:<OrgRegistryKeyInfoComponent
        keys={keys}
        onFormItemChange={onFormItemChange}
        deleteKeys={deleteKeys}
      />,
    isVisible:true,
    }
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OrgRegistryComponent;
